<template>
    <b-modal
            :title="$t(text)"
            :ok-only="true"
            :id="id"
            hide-footer
    >
        <!-- Modal body -->
        <div class="modal-body">
            <div class="flex justify-center items-center gap-3">
                <div class="rounded w-full">
                    <input type="radio" v-model="modelForm.isCompany" :value="false" name="room_type" id="person"
                           checked hidden/>
                    <label for="person"
                           class="radio text-center w-full self-center py-2 px-4 bg-gray-200 rounded cursor-pointer hover:opacity-75">{{
                            $t('person.title')
                        }}</label>
                </div>
                <div class="rounded w-full">
                    <input type="radio" v-model="modelForm.isCompany" :value="true" name="room_type" id="company"
                           hidden/>
                    <label for="company"
                           class="radio text-center w-full self-center py-2 px-4 bg-gray-200 rounded cursor-pointer hover:opacity-75">{{
                            $t('company.title')
                        }}</label>
                </div>
            </div>

            <!--  if is company  -->
            <template v-if="modelForm.isCompany">
                <div class="grid grid-cols-2 mt-4">
                    <div class="position-relative">
                        <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute bottom-8 ml-2">
                            {{ $t('company.name') }}
                        </div>
                        <InputBox
                            class="pl-0 pr-1"
                            model-name="companyName"
                            check-to-model="modelNotEmptyState"
                            :model-form="modelForm"
                            :errors="errors"
                            :model-state="modelNotEmptyState"
                        />
                    </div>

                    <div class="position-relative">
                        <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute bottom-8 ml-2">
                            {{ $t('company.telephone') }}
                        </div>
                        <InputBox
                            class="pr-0 pl-1"
                            model-name="companyTelephone"
                            check-to-model="modelPhoneOrEmpty"
                            :model-form="modelForm"
                            :errors="errors"
                        />
                    </div>
                </div>

                <SubmitRow
                    btn-variant="bg-main rounded w-full h-10 text-white cursor-pointer btn hover:bg-hoverMain"
                    class="mt-5"
                    v-if="canManageCustomers()"
                    text="add"
                    :is-disabled="hasErrorsIn(errorsCompany)"
                    :is-loading="isLoading"
                    :do-action="addCustomer"
                    :md-size="'12'"
                    :sm-size="'12'"
                />
            </template>

            <template v-if="!modelForm.isCompany">
                <div class="grid grid-cols-2 mt-5">
                    <div class="position-relative">
                        <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute bottom-8 ml-2">
                            {{ $t('person.givenName') }}
                        </div>
                        <InputBox
                            class="pl-0 pr-1.5"
                            model-name="givenName"
                            :model-form="modelForm"
                            :errors="errors"
                            check-to-model="modelNotEmptyState"
                            :column-no-top-margin="true"
                        />
                    </div>

                    <div class="position-relative">
                        <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute bottom-8 ml-2">
                            {{ $t('person.familyName') }}
                        </div>
                        <InputBox
                            class="pl-1 pr-0"
                            model-name="familyName"
                            :model-form="modelForm"
                            :column-is-fill="false"
                        />
                    </div>
                </div>
                <div class="mt-5">
                    <div class="position-relative">
                        <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute bottom-8 ml-2">
                            {{ $t('person.telephone') }}
                        </div>
                        <InputBox
                            class="px-0"
                            model-name="telephone"
                            :model-form="modelForm"
                            :errors="errorsPerson"
                            check-to-model="modelPhoneOrEmpty"
                            :no-margin-top="true"
                        />
                    </div>

                </div>

                <div class="flex justify-center items-center gap-3 mt-5">
                    <div class="rounded w-full">
                        <input type="radio" v-model="modelForm.gender" :value="1" name="gender" id="man" checked
                               hidden/>
                        <label
                                for="man"
                                class="radio text-center w-full self-center py-2 px-4 bg-gray-200 rounded cursor-pointer hover:opacity-75"
                        >{{ $t('person.gender.man') }}
                        </label>
                    </div>
                    <div class="rounded w-full">
                        <input type="radio" v-model="modelForm.gender" :value="0" name="gender" id="woman" hidden/>
                        <label
                                for="woman"
                                class="radio text-center w-full self-center py-2 px-4 bg-gray-200 rounded cursor-pointer hover:opacity-75"
                        >{{ $t('person.gender.woman') }}
                        </label>
                    </div>
                </div>

                <SubmitRow
                    btn-variant="bg-main rounded w-full h-10 text-white cursor-pointer btn hover:bg-hoverMain"
                    class="mt-4"
                    v-if="canManageCustomers()"
                    text="add"
                    :is-disabled="hasErrorsIn(errorsPerson)"
                    :is-loading="isLoading"
                    :do-action="addCustomer"
                    :sm-size="'12'"
                    :md-size="'12'"
                />
            </template>
        </div>
    </b-modal>

</template>

<script>
import InputBox from "@/components/InputBox";
import SubmitRow from "@/components/SubmitRow";
import validatorMixin from "@/mixin/validatorMixin";
import accessMixin from "@/mixin/accessMixin";
import {mapActions} from "vuex";

export default {
    name: "ModalAddCustomer",
    mixins: [validatorMixin, accessMixin],
    props: {
        modelForm: {
            type: Object,
            required: true
        },
        id: {
            type: String,
            required: true,
        },
        text: {
            type: String,
            required: true
        },
    },
    data() {
        return {
            isLoading: false,
            errors: {
                companyName: null,
                companyTelephone: null,
                givenName: null,
                personFamilyName: null,
                personGender: null,
                personTelephone: null,
                debt: null,
                currencyId: null,
            },
        }
    },
    computed: {
        errorsCompany() {
            return {
                companyName: this.errors.companyName,
            }
        },
        errorsPerson() {
            return {
                givenName: this.errors.givenName,
            }
        }
    },
    methods: {
        ...mapActions(['pushCustomer']),
        addCustomer() {
            this.isLoading = true

            if (this.modelForm.isCompany) {
                this.pushCustomer({
                    isCompany: this.modelForm.isCompany,
                    companyName: this.modelForm.companyName,
                    companyTelephone: this.modelForm.companyTelephone,
                    debt: '',
                })
                    .then((response) => {
                        this.$emit('chooseCustomer', response)
                    })
                    .catch((reason) => {
                        if (reason === 'You have not available credits') {
                            this.modalText = this.$t('error.overLimit')
                            this.$bvModal.show('modal_show')
                        } else {
                            this.modalText = reason
                            this.$bvModal.show('modal_show')
                        }
                    })
            } else {
                this.pushCustomer({
                    isCompany: this.modelForm.isCompany,
                    personGivenName: this.modelForm.givenName,
                    personFamilyName: this.modelForm.familyName,
                    personGender: this.modelForm.gender,
                    personTelephone: this.modelForm.telephone,
                    debt: '',
                })
                    .then((response) => {
                        this.$emit('chooseCustomer', response)
                    })
                    .catch((reason) => {
                        if (reason === 'You have not available credits') {
                            this.modalText = this.$t('error.overLimit')
                            this.$bvModal.show('modal_show')
                        } else {
                            this.modalText = reason
                            this.$bvModal.show('modal_show')
                        }
                    })
            }
            setTimeout(() => {
                this.isLoading = false
            }, 3000)
        },
    },
    components: {
        InputBox,
        SubmitRow,
    }
}
</script>

<style scoped>
input:checked ~ .radio {
    color: white;
    background-color: #6539B2;
}
</style>
